import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { GetComparativeTableV2QueryResponse, GetComparativeTableV2QueryParams } from "../../types/GetComparativeTableV2";

/**
     * @link /api/purchase-tenders/v2/comparative-table
     */
export async function getComparativeTableV2 (params: GetComparativeTableV2QueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<GetComparativeTableV2QueryResponse>["data"]> {
    const { data: resData } = await client<GetComparativeTableV2QueryResponse>({
        method: "get",
        url: `/api/purchase-tenders/v2/comparative-table`,
        params,
        ...options
    });
    
    return resData;
};